import { useState } from "react";
import CreateNewCreditzForm from "./form";
import Header from "./header";
import PropTypes from "prop-types";

const CreateNewCreditz = ({ values = {}, setValues, setView }) => {
  const [publishActive, setPublishActive] = useState(false);
  
  return (
    <>
      <CreateNewCreditzForm
        setValues={setValues}
        values={values}
        setPublishActive={setPublishActive}
        publishActive={publishActive}
        setView={() => setView()}
      />
    </>
  );
};

CreateNewCreditz.propTypes = {
  values: PropTypes.object,
  setView: PropTypes.func,
  setValues: PropTypes.func,
};

export default CreateNewCreditz;
